module.exports = __webpack_public_path__ + "static/media/acmg-the-archive.e89085da.png";